import React from 'react';

import Page from 'sharedreact/components/Page';
import PageContent from 'sharedreact/components/PageContent';
import PageNotFoundMessage from 'sharedreact/components/PageNotFoundMessage';
import Toolbar from 'sharedreact/components/Toolbar';

type Props = {
  language: string
};

class PageNotFound404ErrorPage extends React.PureComponent<Props> {
  override render (): React.ReactNode {
    const { language } = this.props;

    return (
      <Page>
        <Toolbar>
          <h1 style={{visibility: 'hidden'}}>dummy</h1>
        </Toolbar>
        <PageContent noPadding horizontal>
          <PageNotFoundMessage language={language} />
        </PageContent>
      </Page>
    );
  }
}

export default PageNotFound404ErrorPage;
